import {Component} from 'react';
import axios from "axios"
import Nav from "../../Componet/Nav";
import Swal from "sweetalert2";
import myconfig from "../../myconfig";
import * as XLSX from "xlsx";

let source = axios.CancelToken.source();

class Master_trip_2 extends Component {
    constructor() {
        super();
        var date = new Date();
        this.state = {
            allovehs: [],
            filter:[],
            allovehsl: false,
            st:'',
            ed:'',
            txtsearch: '',
        }
    }

    async componentDidMount() {
    }
    inputmgt = (event) => {
        event.preventDefault();
        var name = event.target.name;
        var value = event.target.value;
        this.setState({
            [name]: value,
        })
    }
    tabledata = () => {
        let retdata = null;
        if (this.state.allovehsl) {
            retdata = this.state.filter.map(value => {
                return (<tr>
                    <td>{value.created_at}</td>
                    <td>{value.frightno}</td>
                    <td>{value.sale_type}</td>
                    <td>{value.type}</td>
                    <td>{value.tran_type}</td>
                    <td>{value.tran_name}</td>
                    <td>{value.plate_no}</td>
                    <td>{value.tra_plateno}</td>
                    <td>{value.dri_name}</td>
                    <td>{value.dri_phoneno}</td>
                    <td>{value.dri_Lic_no}</td>
                    <td>{value.companyname}</td>
                    <td>{value.org}</td>
                    <td>{value.des}</td>
                    <td>{value.cargo_name}</td>
                    <td>{value.loadedweight}</td>
                    <td>{value.km}</td>
                    <td>{value.dateofallocation}</td>
                    <td>{value.dateofarivalatloadpoint}</td>
                    <td>{value.dateofloading}</td>
                    <td>{value.dateofdeparture}</td>
                    <td>{value.dateofarivalatoffloadpoint}</td>
                    <td>{value.dateofoffloading}</td>
                    <td>{value.transport_rate_q}</td>
                    <td>{value.cement_rate_q}</td>
                    <td>{value.cement_cost}</td>
                    <td>{value.fuelempty}</td>
                    <td>{value.fuelload}</td>
                    <td>{value.prediemempty}</td>
                    <td>{value.predieload}</td>
                    <td>{value.handlefeeempty}</td>
                    <td>{value.handlefeeload}</td>
                    <td>{value.rev_tpt}</td>
                    <td>{value.rev_cmt}</td>
                    <td>{value.tot_rev}</td>
                    <td>{value.tot_exp}</td>
                    <td>{value.gp}</td>
                </tr>)
            })
        }
        return (<>{retdata}</>)
    }
    btnexport = (event) => {
        event.preventDefault();
        let wb=XLSX.utils.book_new();
        wb.SheetNames.push("Master Trip");
        let wb2= XLSX.utils.table_to_sheet(document.getElementById('report_1'));
        wb.Sheets["Master Trip"]=wb2;
        XLSX.writeFile(wb,"Master Trip Data.xlsx");
    }
    btngetreport = (event) => {
        event.preventDefault();
        let baseurl = myconfig.master_trip_2;
        let redirecttologin = myconfig.redirecttologin;
        this.setState({
            allovehs: [],
            filter:[],
            allovehsl: false,
            cushow: false,
        })
        axios.post(baseurl, {
            sid: window.localStorage.getItem("ntfms_sid"),
            st: this.state.st,
            ed: this.state.ed,
        }, {cancelToken: source.token}).then(res => {
            if (res.data.auth == false) {
                window.localStorage.setItem("ntfms_sid", null);
                window.localStorage.setItem("ntfms_username", null);
                window.localStorage.setItem("ntfms_name", null);
                var win = window.open(redirecttologin, "_self");
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.setState({
                    allovehs: res.data,
                    filter: res.data.datas,
                    allovehsl: true,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }

    componentWillUnmount() {
        try {
            if (source) {
                source.cancel("Landing Component got unmounted");
            }
        } catch (e) {

        }
    }
    inputmgt_search = (event) => {
        event.preventDefault();
        if (this.state.allovehsl===true) {
            var name = event.target.name;
            var value = event.target.value;
            let temp = this.state.allovehs.datas;
            if (value != "") {
                temp = this.state.allovehs.datas.filter(v => {
                    if (v.plate_no.toUpperCase().includes(value.toUpperCase())) {
                        return v;
                    }
                })
            }
            this.setState({
                filter: temp,
            })
        }
    }
    render() {
        return (
            <>
                <Nav type="master_trip_2"/>
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0">Daily Master Trip (v2)</h1>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item"><a href={this.state.urlorder}>Master Trip (v2)</a>
                                        </li>
                                        <li className="breadcrumb-item active"></li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="card card-primary">
                                    <div className="card-header">
                                        <h3 className="card-title">Report Criteria</h3>
                                    </div>
                                    <form>
                                        <div className="card-body">
                                            <div className="form-group">
                                                <label>Start Date</label>
                                                <input type="date" name="st" className="form-control" value={this.state.st} onChange={this.inputmgt} />
                                            </div>
                                            <div className="form-group">
                                                <label>End Date</label>
                                                <input type="date" name="ed" className="form-control" value={this.state.ed} onChange={this.inputmgt} />
                                            </div>
                                        </div>
                                        <div className="card-footer">
                                            <button type="submit" className="btn btn-primary" onClick={this.btngetreport}>Get report</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <div className="card-tools">
                                            <div className="input-group input-group-sm">
                                                <a href="" onClick={this.btnexport}>Download .xlsx</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-header">
                                        <div className="card-tools">
                                            <div className="input-group input-group-sm" style={{width: '150px'}}>
                                                <input type="text" name="txtsearch_order"
                                                       onChange={this.inputmgt_search}
                                                       className="form-control float-right"
                                                       value={this.state.txtsearch_order} placeholder="Search"/>
                                                <div className="input-group-append">
                                                    <button type="submit" className="btn btn-default">
                                                        <i className="fas fa-search"/>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body table-responsive p-0" style={{height: '500px'}}>
                                        <table id="report_1" className="table table-head-fixed text-nowrap">
                                            <thead>
                                            <tr>
                                                <th>FO DATE</th>
                                                <th>FREIGHT ORDER #</th>
                                                <th>SALES TYPE</th>
                                                <th>TYPE</th>
                                                <th>TRANSPORTER TYPE</th>
                                                <th>TRANSPORTER NAME</th>
                                                <th>TRUCK No.</th>
                                                <th>TRAILER NO</th>
                                                <th>DRIVER NAME</th>
                                                <th>TELEPHONE NO</th>
                                                <th>LICENSE NO</th>
                                                <th>CUSTOMER</th>
                                                <th>ORIGIN</th>
                                                <th>DESTINATION</th>
                                                <th>CARGO</th>
                                                <th>LOADED WEIGHT</th>
                                                <th>TOTAL KMS (ONE WAY)</th>
                                                <th>DATE OF ALLOCATION</th>
                                                <th>DATE & TIME OF ARRIVAL AT LOADING POINT</th>
                                                <th>DATE & TIME OF LOADING	DATE</th>
                                                <th>DATE & TIME OF DEPARTURE</th>
                                                <th>DATE & TIME OF ARRIVAL AT OFFLOADING POINT</th>
                                                <th>DATE  & TIME OF OFFLOADING</th>
                                                <th>TRANSPORT RATE PER QUINTAL</th>
                                                <th>CEMENT RATE PER QUINTAL</th>
                                                <th>CEMENT COST PER QUINTAL</th>
                                                <th>FUEL EMPTY</th>
                                                <th>FUEL LOADED</th>
                                                <th>PRE-DIEM EMPTY</th>
                                                <th>PRE-DIEM LOADED</th>
                                                <th>HANDLING FEE EMPTY</th>
                                                <th>HANDLING FEE LOADED</th>
                                                <th>Revenue Transport</th>
                                                <th>Revenue Commodity</th>
                                                <th>Revenue Total</th>
                                                <th>Expense Total</th>
                                                <th>GP</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {this.tabledata()}
                                            </tbody>
                                        </table>
                                    </div>
                                    {/* /.card-body */}
                                </div>
                                {/* /.card */}
                            </div>
                        </div>
                    </section>
                </div>
            </>
        )
    }
}

export default Master_trip_2;
